import { Reduction } from "Domain/Model/Reduction/Reduction";

export const FIND_REDUCTION_SUCCESS = 'FIND_REDUCTION_SUCCESS';

export const findReductionSuccess = (reduction: Record<string, Reduction>) => ({
    type: FIND_REDUCTION_SUCCESS,
    payload: { reduction },
});
